export enum LoadingTypes {
    INIT,
    LOADING,
    LOADED,
    FAIL
}
